<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(221,114,2); 
            border-bottom: solid 0.06rem rgb(193,193,193);">
            Gene expression
        </p>
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               font-size: 14px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 18px;text-align: left;line-height: 23px;">
                In this section, we selected some representative  <strong style="font-size:22px;">gene expression</strong> datasets of MDD from the GEO database. 
                These datasets include samples from the brain or blood tissues. 
                <br/>We used the box scatter plot to display the gene expression profile 
                and the <a href="https://bioconductor.org/packages/release/bioc/html/limma.html">Limma</a> package to do the differential expression analysis.
                We did not filter the results of differential expression analysis and you can choose the threshold yourself.
               </div>
        </el-card>
       <el-tabs style="height:auto;margin-top: 50px;" type="border-card" v-model="activePane">
        <el-tab-pane label="Gene expression profile" name="profile">
            <div style="width:30%;height:auto;display: inline-block;vertical-align: middle;">
                    Select an expression data set: <br/>
                    <el-select v-model="activeDataset" placeholder="Choose type" style="display: inline-block;width: 80%;">
                        <el-option
                            v-for="item in geneOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <br/><br/>
                    Enter single gene name here: <br/>
                <input type="text" placeholder="Enter single gene name here" v-model="searchGene" style="height:35px;width:80%">
                <br/><br/>
                <el-button size="small" @click="getPlotData()" type="warning" style="font-size: 16px;text-align:center;margin-left:1%;width:80%;height:40px;">Submit</el-button>
            </div>

            <el-descriptions :column="3" style="width: 69%;display: inline-block;vertical-align:middle;" border>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >GEO accession</template>
                    <template>
                        <a :href="'https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc='+this.activeData[this.activeDataset].accession">    {{this.activeData[this.activeDataset].accession}}   </a>
                    </template>
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Case and Control</template>
                    {{this.activeData[this.activeDataset].sample}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Tissue</template>
                    {{this.activeData[this.activeDataset].tissue}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Gender</template>
                    {{this.activeData[this.activeDataset].gender}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Age</template>
                    {{this.activeData[this.activeDataset].age}} 
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >PMID</template>
                    <template>
                        <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+this.activeData.pmid">    {{this.activeData[this.activeDataset].pmid}}   </a>
                    </template>
                </el-descriptions-item>     
                <el-descriptions-item labelStyle="width: 150px" contentStyle="width: 250px" >
                    <template slot="label" >Citation</template>
                    {{this.activeData[this.activeDataset].citation}} 
                </el-descriptions-item>
            </el-descriptions>  
            <div id="boxplotGene">
                <BoxplotchartVue :jsonData="jsonData" 
                    :title="activeData[activeDataset].array" 
                    :value_type='activeData[activeDataset].value_type '
                    :tooltip='activeData[activeDataset].tooltip'
                    :plotTitle="title"></BoxplotchartVue>
            </div> 
            
        </el-tab-pane>
        <!-- data -->
        <el-tab-pane label="Differential expressed gene analyis" name="result">

           <!-- selecter -->
            <div style="display: flex; align-items:center;justify-content:center;"> 
                Select domains: 
                <span style="width: 20px;"></span>
                <el-select @change="selectChanged" v-model="activeDataset" placeholder="Choose type" >
                    <el-option
                    v-for="item in geneOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <span style="width: 50px;"></span>
                <div style="margin-right: 0%;"><a href="javascript:void(0)" @click="download('deg_filter')" style="width:200px; ">download</a></div>
            </div>
                   
            <br/><br/>
            <div style="display: flex">
                <span style="width:50px"></span>
                <div class="slider-demo-block">
                    <span class="demonstration">p.value</span>
                    <el-slider class="slider" @change="getData" v-model="p_value" show-input :max="1" :step="0.05" style="width:350px"></el-slider>
                </div>
                <span style="width:100px"></span>
                <div class="slider-demo-block">
                    <span class="demonstration">p.adjust</span>
                    <el-slider class="slider" @change="getData" v-model="p_adjust" show-input :max="1" :step="0.05" style="width:350px"></el-slider>
                </div>
                <span style="width:100px"></span>
                <div class="slider-demo-block">
                    <span class="demonstration">|logFC|</span>
                    <el-slider class="slider" @change="getData" v-model="logfc" show-input style="width:350px" :step="0.5" :max="12"></el-slider>
                </div>
                    <!-- p.value:<el-slider class="slider" v-model="p_value" show-input max="1" step="0.05" style="width:25%"></el-slider>
                <span></span>p.adjust:<el-slider class="slider" v-model="p_adjust" show-input max="1" step="0.05" style="width:25%"></el-slider>
                <span></span>|logFC|: <el-slider class="slider" v-model="logfc" show-input style="width:25%" step="0.5" max="12"></el-slider> -->
            </div>
                
            <el-table ref="table" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=auto @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
        </el-tab-pane>
       </el-tabs>
       
        
    </div>
</template>
<script>
import{Loading}from'element-ui';
import BoxplotchartVue from '../../../chart/Boxplotchart.vue'
export default ({
    data(){
        return{
            geneOption:[{
                value: 'GSE98793-batch1',
                label: 'GSE98793-batch1(blood)'
            },{
                value: 'GSE98793-batch2',
                label: 'GSE98793-batch2(blood)'
            },{
                value: 'GSE102556-BA11',
                label: 'GSE102556-BA11(brain)'
            },{
                value: 'GSE102556-aINS',
                label: 'GSE102556-aINS(brain)'
            },{
                value: 'GSE102556-BA8_9',
                label: 'GSE102556-BA8/9(brain)'
            },{
                value: 'GSE102556-Cg25',
                label: 'GSE102556-Cg25(brain)'
            },{
                value: 'GSE102556-Nac',
                label: 'GSE102556-Nac(brain)'
            },{
                value: 'GSE102556-Sub',
                label: 'GSE102556-Sub(brain)'
            },],
            activePane:'profile',
            // plot
            title:null,
            searchGene:"BDNF",
            activeDataset:'GSE98793-batch1',
            activeData:{
                'GSE98793-batch1':{
                    'array':['value','gene_name','sample','age','anxiety','batch','gender','type','tissue'],
                    'value_type':'log2 GC-RMA signal',
                    'tooltip':['sample', 'value','age','anxiety','gender'],
                    'accession':'GSE98793',
                    'sample':'Case-64\nControl-32',
                    'tissue':'Whole blood',
                    'gender':'Female-72\nMale-24',
                    'age':'50.74±11.18',
                    'platform':'GPL570',
                    'pmid':'28688579',
                    'citation':'Leday GGR, Vértes PE, Richardson S, Greene JR et al. Replicable and Coupled Changes in Innate and Adaptive Immune Gene Expression in Two Case-Control Studies of Blood Microarrays in Major Depressive Disorder. Biol Psychiatry 2018 Jan 1;83(1):70-80.',
                },
                'GSE98793-batch2':{
                    'array':['value','gene_name','sample','age','anxiety','batch','gender','type','tissue'],
                    'value_type':'log2 GC-RMA signal',
                    'tooltip':['sample', 'value','age','anxiety','gender'],
                    'accession':'GSE98793',
                    'sample':'Case-64\nControl-32',
                    'tissue':'Whole blood',
                    'gender':'Female-72\nMale-24',
                    'age':'53.34±11.62',
                    'platform':'GPL570',
                    'pmid':'28688579',
                    'citation':'Leday GGR, Vértes PE, Richardson S, Greene JR et al. Replicable and Coupled Changes in Innate and Adaptive Immune Gene Expression in Two Case-Control Studies of Blood Microarrays in Major Depressive Disorder. Biol Psychiatry 2018 Jan 1;83(1):70-80.',
                },
                'GSE102556-BA11':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Orbitofrontal (OFC; BA11)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-BA8_9':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Dorsolateral prefrontal cortex (dlPFC; BA8/9)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-Cg25':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-13\nControl-15',
                    'tissue':'Cingulate gyrus 25 (Cg25)',
                    'gender':'Female-17\nMale-11',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-aINS':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Anterior Insula (aINS)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-Nac':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-26\nControl-22',
                    'tissue':'Nucleus Accumbens (Nac)',
                    'gender':'Female-22\nMale-26',
                    'age':'46.54±15.15',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
                'GSE102556-Sub':{
                    'array':['value','gene_name','sample','geo_accession','tissue','gender',
                            "cause_of_death",'age',"pmi","ph",'type',"alcool","drug","medication","smoking","rin"],
                    'value_type':'FPKM',
                    'tooltip':['sample','value','age','gender','age',"cause of death","pmi","ph","rin","alcool","drug","medication","smoking"],
                    'accession':'GSE102556',
                    'sample':'Case-24\nControl-19',
                    'tissue':'Subiculum (Sub)',
                    'gender':'Female-19\nMale-24',
                    'age':'45.91±13.49',
                    'platform':'GPL11154',
                    'pmid':'28825715',
                    'citation':'Labonté B, Engmann O, Purushothaman I, Menard C et al. Sex-specific transcriptional signatures in human depression. Nat Med 2017 Sep;23(9):1102-1111.',
                },
            },
            jsonData:[],
            // table
            tableData:[],
            currentPage:1,
            totalCount:1,
            pageSize:10,
            desc:null,
            sortby:null,
            p_value:0.1,
            p_adjust:0.4,
            logfc:0.2,
            tableFields: [
                { key: "gene_name", label: "Gene name", sortable: true},
                { key: "logfc", label: "LogFC", sortable: true},
                { key: "aveexpr", label: "AveExpr", sortable: true},
                { key: "t", label: "T", sortable: true},
                { key: "p_value", label: "p.value", sortable: true,formatter:this.rounding},
                { key: "p_adjust", label: "p.adjust", sortable: true ,formatter:this.rounding},
                { key: "b", label: "B",sortable: true ,formatter:this.rounding},
            ],
        }
    },
    watch:{
        activePane:function(){
            this.jsonData=[]
            if(this.activePane=='profile')this.getPlotData()
            else this.getData()
        }
    },
    components:{
        BoxplotchartVue
    },
    mounted(){
        this.getPlotData()
    },
    methods:{
        getPlotData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#boxplotGene')
            });
            this.axios.get(this.GLOBAL.rootAddress+'visualization/expression/gene',{
            params: { 
                'geo':this.activeDataset,
                'gene_name':this.searchGene
                }
            })
            .then(response=> {      
                loadingInstance.close();
                console.log(this.jsonData)
                this.title=this.activeDataset+":"+this.searchGene
                this.jsonData=response.data
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
            
            
        },
        getData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#table')
            });
            this.axios.get(this.GLOBAL.rootAddress+'analysis/differential/expression',{
            params: { 
                'pageNum': this.currentPage,
                'pageSize': this.pageSize,
                'sortBy':this.sortby,
                'desc':this.desc,
                'dataset':this.activeDataset,
                'p_value':this.p_value,
                'p_adjust':this.p_adjust,
                'logfc':this.logfc
                }
            })
            .then(response=> {      
                loadingInstance.close();
                this.totalCount=response.data.data.total;               
                this.tableData=response.data.data.records;   
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
            
            
        },
        download(file){             
            this.axios.get(this.GLOBAL.rootAddress+'analysis/differential/expression/download',{
            params: { 
                'dataset':this.activeDataset,
                'p_value':this.p_value,
                'p_adjust':this.p_adjust,
                'logfc':this.logfc
                },
                responseType: 'blob',
            })
            .then(response=> {      
                let url = window.URL.createObjectURL(response.data);
                let link = document.createElement('a');
                link.href = url;
                link.download = file+".xlsx";
                document.body.appendChild(link);
                link.click();
                link.remove(); 
                window.URL.revokeObjectURL(link.href);
            })
            .catch(error=> {
                console.log(error);
            });
        },
        // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
        },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        rounding(row,column) {
            return row[column.property].toExponential(3)
        },
        selectChanged(){
            if (this.$refs.table){
                this.$refs.table.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            this.getData()
        },
    },
   
})
</script>

<style>
 .el-slider{width:100%;} 
    .el-slider__button {
        background: #FFFFFF;
        border: solid 2px  rgb(255,208,75);
    }
    .el-slider__bar{
        background: rgb(255,208,75);
    }
    .el-slider__stop {
        background-color: #DCDFE6;
    }
    .el-input-number__increase:hover {
        color:rgb(255,208,75) !important
    }
    .el-input-number__decrease:hover {
        color:rgb(255,208,75) !important
    }
    .slider-demo-block .demonstration {
        font-size: 17px;
        line-height: 44px;
        flex: 1;

        white-space: nowrap;
        margin-bottom: 0;
        }
        .slider-demo-block .demonstration + .el-slider {
        flex: 0 0 70%;
    }

</style>
